export default __webpack_public_path__ + "static/media/ep_13.d485527e.png";